/**
 * AxLabs Experiments - Physics Module Index
 *
 * Exports all physics experiments (both manual and generated).
 */
// ============================================================================
// MANUAL EXPERIMENTS
// ============================================================================
export { SimplePendulumSimulation, createSimplePendulum, SIMPLE_PENDULUM_CONFIG, } from './simple-pendulum.js';
export { ProjectileMotionSimulation, createProjectileMotion, PROJECTILE_MOTION_CONFIG, } from './projectile-motion.js';
export { SHMSimulation, createSHM, SHM_CONFIG, } from './shm-spring.js';
export { OhmsLawSimulation, createOhmsLaw, OHMS_LAW_CONFIG, } from './ohms-law.js';
export { NewtonsLawSimulation, createNewtonsLaw, NEWTONS_LAW_CONFIG, } from './newtons-second-law.js';
export { RCCircuitSimulation, createRCCircuit, RC_CIRCUIT_CONFIG, } from './rc-circuit.js';
export { CircularMotionSimulation, createCircularMotion, CIRCULAR_MOTION_CONFIG, } from './circular-motion.js';
// ============================================================================
// GENERATED EXPERIMENTS
// ============================================================================
// Export all generated experiments and category arrays
export { 
// Individual experiment exports by category
AtwoodMachine, DoubleAtwoodMachine, InclinedPlaneFriction, ElasticCollision1D, InelasticCollision1D, Collision2D, PulleyWithFriction, InclineHangingMass, BlockOnMovingSurface, BankedCurveMotion, UnderdampedOscillator, CriticallyDampedOscillator, OverdampedOscillator, ForcedOscillation, CoupledPendulums, CoupledSpringMass, TorsionalPendulum, PhysicalPendulum, StandingWavesString, SoundWaveInterference, DopplerMovingSource, DopplerMovingObserver, BeatFrequency, WaveSuperposition, IdealGasIsothermal, IdealGasAdiabatic, IdealGasIsobaric, IdealGasIsochoric, CarnotCycle, HeatConduction1D, SnellsLawRefraction, TotalInternalReflection, ThinConvergingLens, ThinDivergingLens, ConcaveMirror, ConvexMirror, DoubleSlitInterference, SingleSlitDiffraction, DiffractionGrating, MalusLawPolarization, CoulombsLaw, ElectricFieldPointCharge, ParallelPlateCapacitor, RLCircuitTransient, RLCSeriesResonance, RLCParallelResonance, MagneticForceWire, FaradayLaw, IdealTransformer, LCOscillations, PhotoelectricEffect, ComptonScattering, BlackbodyRadiation, BohrModel, RadioactiveDecay, RadioactiveDecayChain, 
// Category arrays
mechanicsExperiments, oscillationsExperiments, wavesExperiments, thermodynamicsExperiments, opticsExperiments, electromagnetismExperiments, modernPhysicsExperiments, allPhysicsExperiments, experimentCount as physicsExperimentCount, } from './generated/index.js';
// ============================================================================
// ALL PHYSICS EXPERIMENTS ARRAYS
// ============================================================================
import { SIMPLE_PENDULUM_CONFIG } from './simple-pendulum.js';
import { PROJECTILE_MOTION_CONFIG } from './projectile-motion.js';
import { SHM_CONFIG } from './shm-spring.js';
import { OHMS_LAW_CONFIG } from './ohms-law.js';
import { NEWTONS_LAW_CONFIG } from './newtons-second-law.js';
import { RC_CIRCUIT_CONFIG } from './rc-circuit.js';
import { CIRCULAR_MOTION_CONFIG } from './circular-motion.js';
import { allPhysicsExperiments as generatedPhysicsExperiments } from './generated/index.js';
/**
 * Manual physics experiments - these use ExperimentConfig from simulation-core
 * Each has a dedicated SimulationEngine implementation
 */
export const MANUAL_PHYSICS_EXPERIMENTS = [
    SIMPLE_PENDULUM_CONFIG,
    PROJECTILE_MOTION_CONFIG,
    SHM_CONFIG,
    OHMS_LAW_CONFIG,
    NEWTONS_LAW_CONFIG,
    RC_CIRCUIT_CONFIG,
    CIRCULAR_MOTION_CONFIG,
];
/**
 * Generated physics experiments - these are GeneratedExperimentClass instances
 * created from ExperimentSchema using the declarative framework
 */
export const GENERATED_PHYSICS_EXPERIMENTS = [
    ...generatedPhysicsExperiments,
];
/**
 * Combined configs for backward compatibility.
 * For generated experiments, extracts the config from the class.
 */
export const PHYSICS_EXPERIMENTS = [
    ...MANUAL_PHYSICS_EXPERIMENTS,
    ...GENERATED_PHYSICS_EXPERIMENTS.map((ExpClass) => {
        const instance = new ExpClass();
        return instance.config;
    }),
];
//# sourceMappingURL=index.js.map